import { render, staticRenderFns } from "./Software.vue?vue&type=template&id=2a91727e&scoped=true&"
import script from "./Software.vue?vue&type=script&lang=js&"
export * from "./Software.vue?vue&type=script&lang=js&"
import style0 from "./Software.vue?vue&type=style&index=0&id=2a91727e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a91727e",
  null
  
)

component.options.__file = "Software.vue"
export default component.exports